<template>
  <v-layout column align-center v-if="value">
    <div class="display-1 primary--text font-weight-light">{{ value }}</div>
    <div class="caption primary--text font-weight-light">{{ amount }}</div>
    <div class="title font-weight-light">{{ title }}</div>
  </v-layout>
</template>

<script>
export default {
  name: "RecipeStatistic",
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    amount: {
      type: [Number, String],
      default: null
    },
    title: {
      type: String,
      default: null
    }
  }
};
</script>
